import { connect } from "react-redux";
import ProductsBalancesScreen from "./ProductsBalancesScreen";

export default connect((state) => {
  return {
    storehouse: state.storehouse.storehouse,
  };
})(ProductsBalancesScreen);
